import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './ParityFooter.less';

export const ParityFooter = (props) => {
  const { light } = props;
  let footerText = 'footer__text';
  if (light) {
    footerText += ' footer__text--white';
  }

  const currentYear = moment().format('YYYY');

  return (
    <div className="footer">
      <span className={footerText}>{`Copyright Parity Inc. ${currentYear}  –  `}</span>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.paritygo.com/privacypolicy"
        className="footer__link"
      >
        Privacy Policy
      </a>
      <span className={footerText}>&nbsp;&nbsp;–&nbsp;&nbsp;</span>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.paritygo.com/terms-of-use/"
        className="footer__link"
      >
        Terms and Conditions
      </a>
    </div>
  );
};

ParityFooter.propTypes = { light: PropTypes.bool };
ParityFooter.defaultProps = { light: undefined };
